import React from "react";
import { useTemplateData } from "@constants/template";
import PhoneFrameTwo from "../../Common/PhoneFrameTwo";
import ClockIcon from "@components/Common/SvgIcons/ClockIcon";
import InformationIcon from "@components/Common/SvgIcons/InformationIcon";
import MotorbikeIcon from "@components/Common/SvgIcons/MotorbikeIcon";
import { HeartIcon } from "@aureskonnect/react-ui";
import MapsPinIcon from "@components/Common/SvgIcons/MapsPinIcon";
import { NoPicture } from "@components/Common/SvgIcons";

function Preview({ shopData }: any) {
    const { getImageUrl, iuud, getNestedValue } = useTemplateData();
    const color = getNestedValue<string>([
        "Application",
        "Divers",
        "CouleurPrincipale",
    ]);
    const imageBannier = getImageUrl(
        [
            "Application",
            "ChoixBoutique",
            shopData.boutique || "Default",
            "BannierBoutique",
        ],
        iuud
    );
    const imageLogo = getImageUrl(
        [
            "Application",
            "ChoixBoutique",
            shopData.boutique || "Default",
            "LogoBoutique",
        ],
        iuud
    );

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "80vh",
                borderLeft: "1px #c6c7c9 solid",
            }}
        >
            <PhoneFrameTwo>
                {" "}
                <div
                    style={{
                        width: "100%",
                        height: "100%",
                        padding: "1px 1px",
                        boxSizing: "border-box",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            position: "relative",
                        }}
                    >
                        <img
                            src="/images/mapsf.jpg"
                            alt="App Background"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "fill",
                            }}
                        />
                        <div
                            style={{
                                position: "absolute",
                                left: "16%",
                                top: "4.6%",
                                height: "5%",
                                width: "70%",
                                backgroundColor: "rgb(255, 255, 255)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <p
                                style={{
                                    fontSize: "10px",
                                    margin: 0,
                                }}
                            >
                                {shopData?.shopAdress.length > 60
                                    ? `${shopData.shopAdress.slice(
                                          0,
                                          60
                                      )} . . .`
                                    : shopData?.shopAdress}
                            </p>
                        </div>

                        {imageLogo ? (
                            <img
                                src={imageLogo}
                                alt="Logo"
                                style={{
                                    position: "absolute",
                                    left: "69.2%",
                                    bottom: "67.2%",
                                    width: "12%",
                                    height: "6%",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                    backgroundColor: "#fff",
                                }}
                            />
                        ) : (
                            <NoPicture
                                style={{
                                    position: "absolute",
                                    left: "69.2%",
                                    bottom: "67.2%",
                                    width: "12%",
                                    height: "6%",
                                    borderRadius: "50%",
                                    objectFit: "contain",
                                    backgroundColor: "#fff",
                                }}
                            />
                        )}
                        <div
                            style={{
                                position: "absolute",
                                left: "3%",
                                width: "80%",
                                bottom: "6px",
                                borderRadius: "14px",
                                backgroundColor: "#fff",
                                height: "160px",
                            }}
                        >
                            <div
                                style={{
                                    position: "relative",
                                    width: "100%",
                                    height: "45%",
                                }}
                            >
                                {imageBannier ? (
                                    <img
                                        src={imageBannier}
                                        alt="Bannier"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            borderTopLeftRadius: "14px",
                                            borderTopRightRadius: "14px",
                                            backgroundColor: "#fff",
                                            objectFit: "fill",
                                        }}
                                    />
                                ) : (
                                    <div
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            backgroundColor: "#fff",
                                            borderTopLeftRadius: "14px",
                                            borderTopRightRadius: "14px",
                                        }}
                                    >
                                        <svg
                                            viewBox="0 0 512 512"
                                            preserveAspectRatio="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                display: "block",
                                            }}
                                        >
                                            <path
                                                d="m470.5957 81.279297c-34.42185 0-68.8442 13.105917-95.05664 39.318363-2.70313 2.70306-5.25726 5.49852-7.68164 8.36718h-300.927732c-17.469173 0-31.929688 13.81309-31.929688 30.9375v368.59766c0 17.12541 14.460795 30.9375 31.929688 30.9375h477.669922c17.46786 0 31.92578-13.81209 31.92578-30.9375v-230.07617c41.25131-52.70874 37.63191-129.32122-10.87305-177.82617-26.21243-26.212446-60.63477-39.318363-95.05664-39.318363zm0 9.941406c31.84315 0 63.68753 12.148457 87.98633 36.447267 48.59763 48.59761 48.59763 127.37504 0 175.97265-48.59764 48.59884-127.37502 48.59884-175.97265 0-48.59884-48.59763-48.59884-127.37501 0-175.97265 24.29881-24.29882 56.14319-36.447267 87.98632-36.447267zm3.38868 36.431637c-2.21558.002-4.43625.088-6.65821.25391-14.22052 1.062-28.49752 5.44001-41.89648 12.62109-2.95807 1.58529-3.54566 5.57679-1.16992 7.94727l113.62304 113.33984c2.37566 2.36928 6.36448 1.77297 7.94336-1.1875 19.02488-35.70013 18.21698-77.56949-12.20898-107.99414-17.26397-17.26397-38.21561-24.99941-59.63281-24.98047zm.97265 9.77149c1.82524.011 3.64341.0903 5.45508.24023 16.57381 1.37186 32.45969 8.36399 46.13477 22.03906 25.58538 25.58428 27.54307 58.86256 13.31835 89.96485l-103.45898-103.20313c12.7099-5.84764 25.77411-9.11825 38.55078-9.04101zm-408.027342 1.54101h293.240232c-36.42358 52.38339-31.3016 125.07651 15.36914 171.7461 52.42486 52.42616 137.68843 52.42616 190.11328 0 .2958-.29579.5806-.59862.87305-.89649v218.68555c0 3.51174-.90384 6.82824-2.50391 9.74414l-132.48242-166.72656c-6.06276-7.63018-17.60213-8.15726-24.33594-1.11133l-70.88671 74.15234c-3.03379 3.17442-6.36697 2.98987-9.03516-.49804l-93.24609-121.90039c-2.93889-3.84178-7.27031-6.17129-11.7461-6.16407-4.47579.007-8.79843 2.34983-11.72461 6.20118l-163.492184 215.21679c-1.329813-2.70929-2.072266-5.73148-2.072266-8.91406v-368.59766c0-11.5056 9.67386-20.9375 21.929688-20.9375zm332.369142 29.89649c-1.85035.0155-3.54085 1.05164-4.39453 2.69336-18.47748 35.55774-17.51368 76.94246 12.66601 107.12304.00044.00043.004-.00043.004 0v.002c29.91704 29.91615 70.77586 31.04237 106.17578 13.14843 3.02414-1.53043 3.68183-5.5625 1.30078-7.9746l-112.15048-113.5059c-1.06046-1.06046-2.23667-1.48633-3.60156-1.48633zm1.62109 13.71094 101.89258 103.12109c-30.72709 13.24025-63.07533 11.00975-88.16992-14.08594-25.33111-25.33001-27.43622-58.13123-13.72266-89.03515zm-256.51367 6.1875c-28.91232 0-52.457031 23.54665-52.457031 52.45898s23.544711 52.45508 52.457031 52.45508c28.91233 0 52.45898-23.54275 52.45898-52.45508s-23.54665-52.45898-52.45898-52.45898zm0 10c23.50793 0 42.45898 18.95105 42.45898 42.45898s-18.95105 42.45508-42.45898 42.45508c-23.50792 0-42.45703-18.94715-42.45703-42.45508s18.94911-42.45898 42.45703-42.45898zm77.90039 127.23632c1.14265-.001 2.4335.46881 3.78711 2.23829l93.24414 121.90234c5.91681 7.73459 17.47832 8.37066 24.20703 1.33008l70.88672-74.15235c3.0287-3.16907 6.55011-3.00654 9.27734.42578l133.44922 167.9375c-3.54145 2.36217-7.85563 3.75977-12.55859 3.75977h-477.669922c-5.002077 0-9.559271-1.58875-13.21875-4.23047l164.814452-216.95898c1.34758-1.77365 2.63861-2.25012 3.78125-2.25196z"
                                                transform="scale(.8)"
                                                text-indent="0"
                                                text-align="start"
                                                text-decoration-line="none"
                                                text-decoration-style="solid"
                                                text-decoration-color="rgb(0,0,0)"
                                                text-transform="none"
                                                block-progression="tb"
                                                white-space="normal"
                                                mix-blend-mode="normal"
                                                solid-color="rgb(0,0,0)"
                                                solid-opacity="1"
                                                fill="currentColor"
                                            />
                                        </svg>
                                    </div>
                                )}
                                <div
                                    style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: "10px",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "8px",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "25px",
                                            height: "25px",
                                            borderRadius: "50%",
                                            backgroundColor:
                                                "rgba(255,255,255,0.8)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            boxShadow:
                                                "0 2px 4px rgba(0,0,0,0.1)",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <InformationIcon
                                            width={15}
                                            height={15}
                                            fill={`${color}`}
                                        />
                                    </div>
                                    <div
                                        style={{
                                            width: "25px",
                                            height: "25px",
                                            borderRadius: "50%",
                                            backgroundColor:
                                                "rgba(255,255,255,0.8)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            boxShadow:
                                                "0 2px 4px rgba(0,0,0,0.1)",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <HeartIcon
                                            width={15}
                                            height={15}
                                            fill={`${color}`}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                    gap: "10px",
                                    padding: "2px 5px",
                                }}
                            >
                                {imageLogo ? (
                                    <img
                                        src={imageLogo}
                                        alt="Logo"
                                        style={{
                                            width: "25px",
                                            height: "25px",
                                            borderRadius: "50%",
                                            objectFit: "fill",
                                            backgroundColor: "#fff",
                                        }}
                                    />
                                ) : (
                                    <NoPicture
                                        style={{
                                            width: "22px",
                                            height: "22px",
                                            borderRadius: "50%",
                                            backgroundColor: "#fff",
                                        }}
                                    />
                                )}
                                <h6 style={{ fontSize: "12px" }}>
                                    {shopData.shopName}
                                </h6>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                    gap: "8px",
                                    padding: "0px 10px",
                                    marginTop: "2px",
                                }}
                            >
                                <MapsPinIcon
                                    width={15}
                                    height={15}
                                    fill={`${color}`}
                                />
                                <p
                                    style={{
                                        fontSize: "10px",
                                        margin: 0,
                                    }}
                                >
                                    {shopData?.shopAdress.length > 60
                                        ? `${shopData.shopAdress.slice(
                                              0,
                                              60
                                          )} . . .`
                                        : shopData?.shopAdress}
                                </p>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    position: "absolute",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "0px 10px",
                                    marginTop: "2px",
                                    bottom: "8px",
                                    width: "100%",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        gap: "8px",
                                    }}
                                >
                                    <MotorbikeIcon
                                        width={15}
                                        height={15}
                                        fill={`${color}`}
                                    />
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            margin: 0,
                                        }}
                                    >
                                        148 km Loin
                                    </p>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "5px",
                                    }}
                                >
                                    <ClockIcon
                                        width={15}
                                        height={15}
                                        fill="green"
                                    />
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            color: "green",
                                            margin: 0,
                                        }}
                                    >
                                        Ouvert
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PhoneFrameTwo>
        </div>
    );
}

export default Preview;
